import React, { memo } from "react";
import MillSelector from "./MillSelector";
import DateTimePickers from "./DateTimePickers";
import Trigger from "./Trigger";

import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";

const localStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    controlsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'end',
      height: '100%',
      [theme.breakpoints.down("sm")]: {
        padding: "2px",
        margin: "10px",
      },
    },
  }),
);

const Controls = () => {
  const localClasses = localStyles();

  return (
    <div className={localClasses.mainContainer}>
      <div className={localClasses.controlsContainer}>
        <MillSelector />
      </div>
      <div className={localClasses.controlsContainer}>
        <DateTimePickers />
      </div>
      <div className={localClasses.controlsContainer}>
        <Trigger />
      </div>
    </div>
  );
};

export default memo(Controls);
